/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Delivery_3_TermInputs */

const en_services_delivery_3_term = /** @type {(inputs: Services_Delivery_3_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A practical handover`)
};

const lv_services_delivery_3_term = /** @type {(inputs: Services_Delivery_3_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praktiska nodošana`)
};

/**
* | output |
* | --- |
* | "A practical handover" |
*
* @param {Services_Delivery_3_TermInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_delivery_3_term = /** @type {((inputs?: Services_Delivery_3_TermInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Delivery_3_TermInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_delivery_3_term(inputs)
	return en_services_delivery_3_term(inputs)
});